<template>
    <span
        :key="state"
        v-c-tooltip="{ content: label, placement: 'bottom' }"
        class="flex h-11 w-11 items-center justify-center"
        :class="stateClass"
        role="status"
        aria-live="polite"
    >
        <icon :name="iconName" />
        <span class="sr-only">{{ label }}</span>
    </span>
</template>

<script setup lang="ts">
import { trans } from '@/mixins/i18n.js';
import { useConnectivityStore } from '@/stores/connectivity';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const connectivity = useConnectivityStore();
const { state } = storeToRefs(connectivity);

const iconName = computed(() => {
    switch (state.value) {
        case 'online':
            return 'cil-wifi-signal-4';
        case 'checking':
            return 'cil-wifi-signal-2';
        case 'offline':
        case 'retrying':
        default:
            return 'cil-wifi-signal-off';
    }
});

const label = computed(() => {
    switch (state.value) {
        case 'online':
            return trans('connectivity.icon.online');
        case 'checking':
            return trans('connectivity.icon.checking');
        case 'offline':
        case 'retrying':
        default:
            return trans('connectivity.icon.offline');
    }
});

const stateClass = computed(() => {
    switch (state.value) {
        case 'online':
            return 'text-white';
        case 'checking':
            return 'text-white opacity-75 animate-pulse';
        case 'offline':
        case 'retrying':
        default:
            return 'text-warning';
    }
});
</script>
